import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NotificationData } from "../notification-data";

@Component({
    selector: "app-notification-dialog",
    templateUrl: "./notification-dialog.component.html",
    styleUrls: ["./notification-dialog.component.scss"],
    standalone: false
})
export class NotificationDialogComponent {
  data = inject<NotificationData>(MAT_DIALOG_DATA);
  private mdDialogRef = inject<MatDialogRef<NotificationDialogComponent>>(MatDialogRef);


  public close() {
    this.mdDialogRef.close();
  }
}
